import * as types from "./pmt_actionTypes";

const initialState = {
    payment_data: [],
    payment_history: [],
    history_total: 0,
    history_pages: 0,

    loading: true,
};

const pmtReducers = (state = initialState, action) => {
    switch (action.type) {
        case types.get_payment_data:
            return {
                ...state,
                payment_data: action.payload,
                loading: false
            }
        case types.get_payment_history:
            return {
                ...state,
                payment_history: action.payload,
                loading: false
            }
        case types.get_history_total:
            return {
                ...state,
                history_total: action.payload,
                loading: false
            }
        case types.get_history_total_pages:
            return {
                ...state,
                history_pages: action.payload,
                loading: false
            }
        default:
            return state;
    }
};

export default pmtReducers;